import { rendererDefaultWidth } from '../../../../common/renderer/renderer-settings';
import { queryStringValueToRenderOptions } from '../../../../common/renderer/shared';
import { RenderOptions, RenderViewQueryParams } from '../../../../common/renderer/types';
import { useQueryParams } from '../../../common/generic/hooks/url-handling/query-params';

export function useRenderViewOptions(): Partial<RenderOptions> {
  // TODO: this hook could/should be called directly in the RenderApiProfile component, and the options would be passed as a prop instead of providing them via the context.
  const [params] = useQueryParams<RenderViewQueryParams>(['data']);
  const optionsInParams: Partial<RenderOptions> = params.data ? queryStringValueToRenderOptions(params.data) : {};
  if (optionsInParams.isShareImg) {
    throw Error('isShareImg is not supported in api profile render view');
  }
  return { ...optionsInParams, width: optionsInParams.width || rendererDefaultWidth };
}
